<template>
    <p class="mb-0">
        <span v-if="showLabel" :class="['main-text', 'small-main-text']">
            {{ $t('results.offerBlocks.term') }}
        </span>

        <span :class="['main-text', 'small-main-text']" v-else>
            {{ offer.term_display }} <span class="sub-text">{{ $t('results.month') }} </span>
        </span>

        <span class="small-text d-flex align-self-start">
            {{ $t('results.loanTerms') }}
        </span>
    </p>
</template>

<script>
export default {
    props: {
        showLabel: false,
    },
    inject: ['offer'],
}
</script>
